import { render, staticRenderFns } from "./LicenseExpiredPopUp.vue?vue&type=template&id=bddfb540&scoped=true&"
import script from "./LicenseExpiredPopUp.vue?vue&type=script&lang=js&"
export * from "./LicenseExpiredPopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bddfb540",
  null
  
)

export default component.exports